




























































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import { GetCenter } from "@/request/idr";
import { GetPaperDetail } from "@/request/zsk";
@Component({
  components: {
    MainHeader,
  },
})
export default class KnowledgeMain extends Vue {
  private get user() {
    return this.$store.state.user;
  }
  private message: any = {};
  /**
   * @description 初始化
   */
  private mounted() {
    this.getMessage(this.$route.query.id);
  }
  private getMessage(id) {
    const params = {
      params: {
        paper_id: id,
      },
    };
    GetPaperDetail(this, params).then((data) => {
      this.message = data;
    });
  }
}
